<p>Accounts Payable</p>

<kendo-grid
  [kendoGridBinding]="gridData"
  [kendoGridSelectBy]="selectedCallback"
  [selectedKeys]="mySelection"
  [filterable]="true"
  [resizable]="true"
  [sortable]="true"
  [scrollable]="true"
  [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
  [pageable]="{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: [20, 40, 60],
                  previousNext: true
                 }"
  style="height: 70vh">

  <kendo-grid-column field="itemGLCode" title="Item GL" filterable=false [width]="150"></kendo-grid-column>
  <kendo-grid-column field="exportGL" title="Export" filterable="false" [width]="150"></kendo-grid-column>

</kendo-grid>


